// extracted by mini-css-extract-plugin
export default {"root":"DropDown_root__qJk-2","watchBrandInput":"DropDown_watchBrandInput__gMKWr"};